<template>
  <div class="offer-item grid grid-rows-[auto_1fr] p-8 border border-gray -mb-px -mx-8 w-[calc(100%+4rem)] md:ml-0 md:-mr-px md:w-full">
    <div class="relative overflow-hidden">
      <div class="offer-item__img aspect-square img-clip select-none">
        <!-- image size 720x840  -->
        <img :src="img" :alt="name" loading="lazy" />
        <img :src="img" :alt="name" loading="lazy" />
      </div>
    </div>

    <div class="offer-item__content relative flex flex-col md:pt-6 group">
      <a class="absolute inset-0 text-[0px] z-10" :href="link">{{name}}</a>

      <p class="offer-item__eyebrow text-sm tracking-tight">
        <span v-if="location">{{location}}</span>

        <span v-if="area" class="inline-block px-2 opacity-50">•</span>
        <span v-if="area">
          {{area}}m
          <sup>2</sup>
        </span>

        <span v-if="rooms" class="inline-block px-2 opacity-50">•</span>
        <span v-if="rooms">{{rooms}} Rooms</span>
      </p>

      <h2 class="offer-item__title title text-2xl mt-3 group-hover:underline duration-300">{{name}}</h2>

      <p class="offer-item__price text-sm tracking-tight mt-3 whitespace-nowrap">{{price}}</p>

      <div
        class="arrow-diagonal offer-item__arrow absolute bottom-0 right-0 w-[18px] h-[18px] overflow-hidden"
      >
        <div class="arrow-diagonal-wrapp w-full h-full">
          <svg
            class="absolute w-[18px] h-[18px] translate-x-[-200%] translate-y-[-200%] group-hover:translate-x-0 group-hover:translate-y-0 duration-500 ease-basic-ease transition-transform"
          >
            <use xlink:href="#arrow-45" />
          </svg>

          <svg
            class="absolute w-[18px] h-[18px] group-hover:translate-x-full group-hover:translate-y-full duration-500 ease-basic-ease transition-transform"
          >
            <use xlink:href="#arrow-45" />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'offerItem',

  props: {
    name: {
      type: String,
      required: true,
    },
    location: {
      type: String,
    },
    area: {
      type: String,
    },
    rooms: {
      type: String,
    },
    price: {
      type: String,
    },
    img: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
  },
}
</script>